module.exports = __webpack_public_path__ + "img/human_temp.39bdcf22.svg";